/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { maybe } from '@/features/details/utils';
import { PREVIEW_THEME_ID } from '@/utils/types';

export function urlNoPreviewThemeId(item: string) {
  return maybe(() => {
    const x = new URL(item);
    x.searchParams.delete(PREVIEW_THEME_ID);
    return x.toString();
  }, item)!;
}

export function rmTrailingSlash(cleanUrl: string) {
  if (!cleanUrl) return cleanUrl;
  const qIndex = cleanUrl.indexOf(`?`);
  if (qIndex !== -1) {
    const beforeQuery = cleanUrl.slice(0, qIndex);
    const query = cleanUrl.slice(qIndex);
    return beforeQuery.endsWith(`/`)
      ? beforeQuery.slice(0, -1) + query
      : cleanUrl;
  }
  return cleanUrl.endsWith(`/`) ? cleanUrl.slice(0, -1) : cleanUrl;
}

export function cleanUrlFromSearchAndHash(url: string): string {
  return maybe(() => {
    const u = new URL(url);
    u.hash = ``;
    u.search = ``;
    return u.toString();
  }, url);
}
